import { makeStyles } from '@material-ui/styles';

export default makeStyles({
    titulo: {
        marginTop: "20px",
        marginLeft: "35px",
        marginRight: "35px",
        fontWeight: '500',
        fontSize: '20px',
        lineHeight: '23px',
        color: '#02599E',
    },

    mensaje: {
        margin: '0px 35px',
        fontWeight: '300',
        fontSize: '16px',
        lineHeight: '28px',
        color: '#666666',
        whiteSpace: 'pre-wrap',
    },

    containerBtn: {
        margin: '20px 35px',
    },

    boton: {
        fontWeight: '400',
        fontSize: '18px',
        lineHeight: '20.75px',
    },

    botonCancelar: {
        fontWeight: '400',
        fontSize: '18px',
        lineHeight: '20.75px',
        color: '#BBB',
    },

    btn: {
        color: '#02599E',
        '&:focus': {
            outline: 'none',
        },
        '&:disabled': {
            color: '#DDD',
        },
    },

    containerContenido: {
        // maxHeight: '600px',
        // overflowY: 'auto',
    },

    mensajeAlerta: {
        color: '#D01919',
        fontSize: '18px',
        fontWeight: '300'
    },
});
